import iphone from "../../assets/iphone.png";
import screen from "../../assets/screen.png";
import Vector from "../../assets/Vector.png";
import googlePlay from "../../assets/google-play.svg";
import appStore from "../../assets/app-store.svg";
import "./style.css";

const Header = () => {
	return (
		<header id="Home">
			<div className="header">
				<img src={Vector} alt="Vector" className="Vector" />
				<div className="container">
					<div className="row">
						<div className="col-md-6 col-12 d-flex justify-content-end">
							<div className="squire">
								<div className="title-head">
									<p className="title">A Great App Makes Your Life Better</p>
									<p className="description">
										FM 90 Valet System is an intelligent valet parking and
										vehicle management application designed to make parking
										faster, safer, and more convenient. It connects drivers,
										valet attendants, and parking facilities through a unified
										digital platform that enhances the parking experience using
										smart technology.
									</p>
									<p className="download-now">Download App Now</p>
									<div className="download-apps">
										<a
											href="https://play.google.com/store/apps/details?id=com.cloudliftsolution.parkingClient"
											target="_blank"
											rel="noreferrer">
											<img src={googlePlay} alt="googlePlay" />
										</a>
										<a
											href="https://apps.apple.com/kw/app/fm-90-valet/id6753007444"
											target="_blank"
											rel="noreferrer">
											<img src={appStore} alt="appStore" />
										</a>
									</div>
								</div>
							</div>
						</div>
						<div className="col-md-6 col-12 d-flex justify-content-end justify-center-mobile">
							<div className="phone-head">
								<div className="phone">
									<img src={iphone} className="iphone" alt="iphone" />
									<img src={screen} className="screen" alt="screen" />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</header>
	);
};
export default Header;
